import { render, staticRenderFns } from "./ModalConsecuences.vue?vue&type=template&id=21a1a5fa&"
import script from "./ModalConsecuences.vue?vue&type=script&lang=js&"
export * from "./ModalConsecuences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a1a5fa')) {
      api.createRecord('21a1a5fa', component.options)
    } else {
      api.reload('21a1a5fa', component.options)
    }
    module.hot.accept("./ModalConsecuences.vue?vue&type=template&id=21a1a5fa&", function () {
      api.rerender('21a1a5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalConsecuences.vue"
export default component.exports